import { useTheme } from '../lib/ThemeContext';
import { Moon, Sun } from 'lucide-react';

interface ThemeSwitcherProps {
  moonColor?: 'white' | 'pink';
}

export default function ThemeSwitcher({ moonColor = 'white' }: ThemeSwitcherProps) {
  const { theme, toggleTheme } = useTheme();
  const isDarkTheme = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      className={`group flex items-center justify-center rounded-md bg-transparent transition p-1.5 ${isDarkTheme ? 'hover:bg-white/10' : 'hover:bg-black/10'}`}
      style={{ width: 36, height: 36 }}
      type='button'
    >
      {theme === 'light' ? (
        <Moon className='w-5 h-5 text-black group-hover:text-black transition-colors' />
      ) : (
        <Sun className='w-5 h-5 text-white group-hover:text-white transition-colors' />
      )}
    </button>
  );
}

